{
  "page_404": {
    "title": "404 Page Not Found",
    "heading": "Sorry, page not found!",
    "description": "Sorry, we couldn't find the page you're looking for. Perhaps you've mistyped the URL? Be sure to check your spelling.",
    "go_home": "Go to Home"
  }
}
